import axios, { AxiosResponse } from 'axios'

export interface OnboardPersistState {
  state: string
  context?: Record<string, unknown>
}

export interface OnboardPersistOptions {
  token: string
}

const parseResponse = <T>(response: AxiosResponse<T>): T => {
  if (response.status !== 200) {
    throw response.data
  }
  return response.data
}

const updateState =
  (apiUrl: string) =>
  async (
    stateToPersist: OnboardPersistState,
    { token }: OnboardPersistOptions,
  ): Promise<OnboardPersistState> => {
    const response = await axios.post<OnboardPersistState>(
      apiUrl,
      { data: stateToPersist },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return parseResponse(response)
  }

const deleteState =
  (apiUrl: string) =>
  async ({ token }: OnboardPersistOptions): Promise<undefined> => {
    const response = await axios.delete(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    parseResponse(response)
    return undefined
  }

export const persistState =
  (apiUrl: string) =>
  async (
    stateToPersist: OnboardPersistState | undefined,
    { token }: OnboardPersistOptions,
  ): Promise<OnboardPersistState | undefined> => {
    // Note the `await`s are intentional, so error is thrown locally
    try {
      if (!stateToPersist) {
        return await deleteState(apiUrl)({ token })
      }
      return await updateState(apiUrl)(stateToPersist, { token })
    } catch (error) {
      console.error(`Onboard \`persistState\` error for URL "${apiUrl}": `, error)
      return undefined
    }
  }
